var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0h14v20H3V0zm13 3H4v14h12V3zM8 1h4v1H8V1zm2 18.25a.75.75 0 100-1.5.75.75 0 000 1.5zm-1.436-8.211V7.064H7.538v1.87c-.15-.36-.37-.69-.645-.969-.85-.85-1.983-.9-1.983-.9s.051 1.132.901 1.982c.602.601 1.346.803 1.727.87v2.019h3.077v-.897H8.564zm3.681-1.154c.067.544.316 1.257 1.16 1.257.667 0 1.097-.2 1.379-.469v.962c-.373.22-.853.365-1.47.365-1.682 0-2.063-1.249-2.116-2.115h-1.032v-.898h1.08c.142-.865.621-1.987 2.16-1.987.45-.01.894.095 1.292.304l-.389.798a1.715 1.715 0 00-.903-.244c-.763 0-1.042.604-1.137 1.13h2a.897.897 0 01-.898.897h-1.126z",
    fill: "#9A9CAC"
  })));
}

export default SvgMobileAppIcon;